import { createGlobalStyle } from 'styled-components';

export const GlobalStylesMinimal = createGlobalStyle`
  body {
    background: white;
    filter: grayscale(1);
  }

  .header {
    min-height: 50px;
    height: max-content;
    background: white;
    color: #000;
    text-shadow: none;
    button i {
      color: #000;
    }
  }

  .finder, .editor {
    border: none !important;
  }

  .finder {
    box-shadow: inset 2px 0 6px silver;
  }

  .finder .fa {
    color: rgba(0, 0, 0, 0.3);
  }
`;
